document.addEventListener('DOMContentLoaded', function() {

gsap.registerPlugin(ScrollTrigger);

// basic sroll animation from left & right

gsap.utils.toArray(".reveal").forEach(function(elem) {
    hide(elem); // ensure that the element is hidden initially

    ScrollTrigger.create({
      trigger: elem,
      onEnter: function({ direction }) { 
        if (direction === 1) { // Only animate when scrolling down
          animateFrom(elem); 
        }
      },
      onEnterBack: function({ direction }) { 
        if (direction === 1) { // Only animate when scrolling down
          animateFrom(elem, -1); 
        }
      }
    });
});

function animateFrom(elem, direction) {
  direction = direction || 1;
  var x = 0,
      y = direction * 100;
  if (elem.classList.contains("fromLeft")) {
    x = -200;
    y = 0;
  } else if (elem.classList.contains("fromRight")) {
    x = 200;
    y = 0;
  }
  elem.style.transform = "translate(" + x + "px, " + y + "px)";
  elem.style.opacity = "0";
  gsap.fromTo(elem, {x: x, y: y, autoAlpha: 0}, {
    duration: 1.5, 
    x: 0,
    y: 0, 
    autoAlpha: 1, 
    ease: "expo", 
    overwrite: "auto"
  });
}

function hide(elem) {
  gsap.set(elem, {autoAlpha: 0});
}



gsap.utils.toArray(".reveal").forEach(function(elem) {
    hide(elem); // assure that the element is hidden when scrolled into view
    
    ScrollTrigger.create({
      trigger: elem,
      onEnter: function() { animateFrom(elem) }, 
      onEnterBack: function() { animateFrom(elem, -1) },
      // onLeave: function() { hide(elem) }  assure that the element is hidden when scrolled into view
    });
  });

// Card animation

ScrollTrigger.batch(".card-wrapper", {
   interval: 0.1, // time window (in seconds) for batching to occur. 
   onEnter: batch => gsap.to(batch, {
     autoAlpha: 1, 
     stagger: 0.2}),
});

// List animation
ScrollTrigger.batch(".definition-group dl", {
   interval: 0.1, // time window (in seconds) for batching to occur. 
   onEnter: batch => gsap.to(batch, {  
  x: 5,
  stagger: 0.1}),
});

// Smooth Scroll
(function($){
$('.button').click(function(e){
  e.preventDefault();
  var target = $($(this).attr('href'));
  if(target.length){
    var scrollTo = target.offset().top;
    $('body, html').animate({scrollTop: scrollTo+'px'}, 800);
  }
});
});

// Header top:0 for smartphones

if (window.innerWidth <= 768) { 
  gsap.to(".header", {
    top: 0,
    duration: 0.5,
    ease: "power1.out",
    scrollTrigger: {
      trigger: ".header",
      start: "top top", 
      onEnter: () => document.querySelector(".utility-bar").classList.add("hidden")
    }
  });
}


});
